<template>
  <div class="navTab-filtrate">
    <div class="filtrate-van">
      <div class="brand-list">
        <div
          class="van-typeList van-hairline--bottom"
          v-for="(item) of brandListbackup"
          :key="item.id"
        >
          <div class="van-brand">
            <p class="brand-name">{{item.name}}{{item.multiple ? '（多选）' : ''}}</p>
            <img
              class="iconfont"
              @click="changeClose(item)"
              v-if="!item.close"
              src="@/assets/imgs/jiantou_down.png"
            />
            <img
              class="iconfont"
              @click="changeClose(item)"
              v-if="item.close"
              src="@/assets/imgs/jiantou_up.png"
            />
          </div>
          <div class="list-all" v-if="!item.close">
            <div class="brand-list" v-for="(info,index) of item.options" :key="index">
              <div
                :class="{'list-itemed': info.selected, 'list-item': !info.selected}"
                class="brand"
                @click="selectedItem(item, info)"
              >{{info.value}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="placeholder"></div>
      <div class="van-content">
        <div class="content-false" @click="reset()">重置</div>
        <div class="content-true" @click="confirm()">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Features-header",
  props: {
    brandList: Array,
  },
  data() {
    return {
      brandListbackup: [...this.brandList],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    changeClose(item) {
      this.$set(item, "close", !item.close);
    },
    selectedItem(item, info) {
      if (item.multiple) {
        //多选
        if (info.key == "all") {
          item.options.forEach((vm) => {
            if (vm.value === info.value) {
              this.$set(info, "selected", !info.selected);
            } else {
              this.$set(vm, "selected", false);
            }
          });
        } else {
          this.$set(info, "selected", !info.selected);
          this.$set(item.options[0], "selected", false);
        }
      } else {
        //单选
        item.options.forEach((vm) => {
          if (vm.value === info.value) {
            this.$set(info, "selected", !info.selected);
          } else {
            this.$set(vm, "selected", false);
          }
        });
      }

      //封信筛选条件
    },
    reset() {
      this.brandListbackup.forEach((item) => {
        item.options.forEach((info) => {
          if (info.key == "all") {
            this.$set(info, "selected", true);
          } else {
            this.$set(info, "selected", false);
          }
        });
      });
      this.$emit("reset");
    },
    confirm() {
      this.$emit("refreshData", this.brandListbackup);
    },
  },
};
</script>

<style lang='stylus' scoped>
.navTab-filtrate {
  height: 100%;
  overflow: auto;

  .filtrate-van {
    display: flex;
    flex-direction: column;
    // height: 100%;
    // overflow: hidden;
    padding: 0 24px 0 16px;

    .brand-list {
      .van-typeList {
        .van-brand {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 88px;
          line-height: 88px;

          .brand-name {
            font-size: 24px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }

          .iconfont {
            width: 0.4rem;
            height: 0.35rem;
          }
        }

        .list-all {
          display: flex;
          flex-wrap: wrap;

          .brand-list {
            .brand {
              min-width: 172px;
              // width: 172px;
              height: 72px;
              font-size: 24px;
              font-weight: 400;
              line-height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 14px;
              margin-bottom: 25px;
              padding: 0 10px;
            }

            .list-itemed {
              background: rgba(255, 246, 246, 1);
              border: 1PX solid rgba(225, 32, 32, 1);
              border-radius: 4px;
              color: rgba(225, 32, 32, 1);
            }

            .list-item {
              background: rgba(248, 248, 248, 1);
              border: 1PX solid rgba(248, 248, 248, 1);
              color: rgba(102, 102, 102, 1);
            }
          }
        }
      }
    }

    .placeholder {
      width: 100%;
      height: 120px;
    }

    .van-content {
      position: absolute;
      bottom: 0;
      right: 0;
      display: flex;
      width: 100%;
      height: 120px;
      justify-content: flex-end;
      padding-right: 24px;
      align-items: center;
      background: #ffffff;

      .content-false {
        line-height: 72px;
        text-align: center;
        width: 176px;
        height: 72px;
        background: rgba(255, 255, 255, 1);
        border: 1PX solid rgba(225, 32, 32, 1);
        border-radius: 36px;
        font-size: 32px;
        font-weight: 400;
        color: rgba(225, 32, 32, 1);
        margin-right: 16px;
      }

      .content-true {
        width: 176px;
        height: 72px;
        line-height: 72px;
        text-align: center;
        background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
        border-radius: 40px;
        font-size: 32px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
